/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Checkbox,
  checkboxClasses,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Icons } from '../../../assets/SvgIcons';
import { getAssetsPlaybooks } from '../../../store/feature/assetsSlice';
import { useAppSelector } from '../../../store/hooks';
import classes from './../../../components/UI/TodoCard/TodoCard.module.css';

interface ManagePlaybooksProps {
  open: boolean;
  handleClose: (close: boolean) => void;
}

interface PlaybookSettings {
  playbookName: string;
  statusUpdate: boolean;
  comment: boolean;
  actionableAdded: boolean;
}

export default function ManagePlaybooks(props: ManagePlaybooksProps) {
  const { open, handleClose } = props;
  const { id } = useParams();
  const dealfunctions = useAppSelector(getAssetsPlaybooks);

  const [playbookSettings, setPlaybookSettings] = useState<PlaybookSettings[]>(
    []
  );

  useEffect(() => {
    const currentPlaybookSettings = [] as PlaybookSettings[];
    const deals = dealfunctions?.filter(i => i.dealspaceId === id) ?? [];
    for (const item of deals) {
      currentPlaybookSettings.push({
        playbookName: item.name,
        actionableAdded: false,
        comment: false,
        statusUpdate: false,
      });
    }
    setPlaybookSettings(currentPlaybookSettings);
  }, [id]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="add-user-dialog"
      >
        <div className="dialog-header">
          <div className={classes.infoModalHeader}>
            Workstream notification setting
          </div>
          <button
            className="dialog-close-button"
            onClick={() => {
              handleClose(false);
            }}
          >
            <Icons.Cancel width="22" height="22" color="#000000" />
          </button>
        </div>

        <div className="dialog-content">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Workplan</TableCell>
                <TableCell>Status update</TableCell>
                <TableCell>Comment</TableCell>
                <TableCell>Actionable added</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {playbookSettings.map((i, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {i.playbookName}
                    </TableCell>
                    <TableCell align="center">
                      {' '}
                      <Checkbox
                        sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                            color: '#5D54C0',
                          },
                        }}
                        checked={i.statusUpdate}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {' '}
                      <Checkbox
                        sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                            color: '#5D54C0',
                          },
                        }}
                        checked={i.comment}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {' '}
                      <Checkbox
                        sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                            color: '#5D54C0',
                          },
                        }}
                        checked={i.actionableAdded}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <div style={{ marginTop: 20 }}></div>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <Button
              className="FuchsiaBlueButton"
              style={{
                width: 148,
                marginTop: 20,
                marginRight: 40,
                marginBottom: 30,
              }}
            >
              Apply changes
            </Button>
          </div>
        </div>
        <div></div>
      </Dialog>
    </div>
  );
}
